export const DESKTOP_VIEW_OPEN = 'DESKTOP_VIEW_OPEN'
export const DESKTOP_VIEW_CLOSE = 'DESKTOP_VIEW_CLOSE'
export const MOBILE_VIEW_OPEN = 'MOBILE_VIEW_OPEN'
export const MOBILE_VIEW_CLOSE = 'MOBILE_VIEW_CLOSE'

export const DARK_MODE_OPEN = 'DARK_MODE_OPEN'
export const DARK_MODE_CLOSE = 'DARK_MODE_CLOSE'
